export const wait = (ms: number | undefined): Promise<unknown> => {
  return new Promise((res) => setTimeout(res, ms));
};

/**
 * Defer a callback to the next tick (0ms) or a specified time
 *
 * To clear the timeout:
 * const deferredOnChangeTimeout = deferParentOnChange(() => console.log('callback'));
 * clearTimeout(deferredOnChangeTimeout);
 */
export const deferCallback = (cb: () => void, ms: number = 0) => {
  return setTimeout(() => {
    if (cb && typeof cb === "function") {
      cb();
    }
  }, ms);
};
